export const PASSWORD_RESET_FORM = {
    newPassword: '',
    confirmationNewPassword: '',
  }